var React = require('react');

function IconDiscussionSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M708.1 576.6c-8.3 7.9-18.4 11.8-30.4 11.8h-415l-77.1 76.9c-20.3 20.2-53.1 20.2-73.3-.1-9.7-9.7-15.1-22.9-15.1-36.6V179.5c0-11.1 4-20.6 11.9-28.5s17.6-11.8 28.9-11.8h539.6c11.9 0 22.1 3.9 30.4 11.8 8.3 7.9 12.5 17.3 12.5 28.5v368.6c.1 11.2-4 20.7-12.4 28.5zm178-274.2c11.3 0 20.9 3.9 28.9 11.8s11.9 17.3 11.9 28.5v490.5c0 28.6-23.2 51.9-51.9 51.9-13.6 0-26.7-5.4-36.4-14.9L761.3 794H303.6c-11.3 0-20.9-3.9-28.9-11.8s-11.9-17.3-11.9-28.5V671h539.6V302.4h83.7z"}));
}

IconDiscussionSolid.displayName = "IconDiscussionSolid";

IconDiscussionSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconDiscussionSolid;

IconDiscussionSolid.default = IconDiscussionSolid;
